<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Fabric Families</h4>
      </div>
      <div class="grid-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="sort" @click="sort('id')">#ID</th>
              <th class="sort" @click="sort('hex_code')">Color</th>
              <th class="sort" @click="sort('title_en')">Title (English)</th>
              <th class="sort" @click="sort('title_th')">Title (Thai)</th>
              <th class="sort" @click="sort('title_de')">Title (German)</th>
              <th class="sort" @click="sort('hex_code')">Hex Code</th>
              <th class="sort" @click="sort('fabrics')">Fabrics</th>
              <th class="text-right">
                <button
                  class="btn btn-success"
                  @click="showCreateDialog()"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> New
                  Fabric Family
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(family, index) in families" :key="index">
              <td># {{ family.id }}</td>
              <td>
                <div
                  class="color-prev"
                  :style="{ backgroundColor: family.hex_code }"
                ></div>
              </td>
              <td>{{ family.title_en }}</td>
              <td>{{ family.title_th }}</td>
              <td>{{ family.title_de }}</td>
              <td>{{ family.hex_code }}</td>
              <td>
                <router-link
                  v-if="family.fabrics.length > 0"
                  class="badge badge-default"
                  :to="'/fabric/update/' + fabric"
                  :key="family.id + '_' + fabric"
                  v-for="fabric in family.fabrics"
                >
                  {{ $Fabric.getCode(fabric) }}
                </router-link>
              </td>
              <td class="text-right">
                <button
                  class="btn btn-primary"
                  @click="showUpdateDialog(index)"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                  Edit
                </button>
                <button
                  class="btn btn-danger"
                  @click="deleteFamily(index)"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="editId != null">
              Update Fabric Family
            </h5>
            <h5 class="modal-title text-bold" v-else>New Fabric Family</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label>Title (English) </label>
              <input
                type="text"
                class="form-control"
                v-model="family.title_en"
                placeholder="Title (English)"
              />
              <p v-if="editId != null" class="text-danger">
                If the english title of the fabric family is changed, the fabric
                books related to this family will not be updated automatically.
                Please notify the development team after you update this.
              </p>
            </div>

            <div class="form-group">
              <label>Title (Thai) </label>
              <input
                type="text"
                class="form-control"
                v-model="family.title_th"
                placeholder="Title (Thai) "
              />
            </div>

            <div class="form-group">
              <label>Title (German) </label>
              <input
                type="text"
                class="form-control"
                v-model="family.title_de"
                placeholder="Title (German) "
              />
            </div>
            <div class="form-group">
              <label>Title (German) </label>
              <input
                type="text"
                class="form-control"
                v-model="family.title_de"
                placeholder="Title (German) "
              />
            </div>
            <div class="form-group">
              <label>Domain (optional) </label>
              <select class="form-control" v-model="family.domain">
                <option value="" selected>None</option>
                <option value="color" selected>Color</option>
              </select>
            </div>

            <div class="form-group">
              <label>Hex Code </label>
              <div class="row">
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="family.hex_code"
                    placeholder="#12DCFF"
                  />
                </div>
                <div class="col-md-2">
                  <v-input-colorpicker
                    v-model="family.hex_code"
                    @input="handleInput"
                    @change="handleChange"
                    class="btn btn-block"
                  />
                </div>
              </div>
              <small v-if="errors.hex_code" class="form-text text-danger">{{
                errors.hex_code.join(" ")
              }}</small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId != null"
              @click="updateFamily()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="createFamily()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import InputColorPicker from "vue-native-color-picker";

export default {
  components: {
    "v-input-colorpicker": InputColorPicker,
  },
  data() {
    return {
      errors: {},
      families: [],
      editId: null,
      sortType: "asc",
      isReadOnlyUser: false,
      family: {
        id: null,
        title_en: null,
        title_th: null,
        title_de: null,
        domain: null,
        hex_code: null,
      },
    };
  },
  watch: {
    $route: function () {
      this.getFabricFamilies();
    },
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getFabricFamilies();
  },
  methods: {
    sort(column) {
      this.sortType = this.sortType === "asc" ? "desc" : "asc";
      this.families = _.orderBy(
        this.families,
        [
          (row) => {
            if (column === "fabrics") {
              let fabrics = row[column];
              if (fabrics.length > 0) {
                return fabrics[0];
              } else {
                return "";
              }
            } else {
              return row[column];
            }
          },
        ],
        [this.sortType]
      );
    },

    async getFabricFamilies() {
      try {
        let res = await axios.get("v2/fabrics/fabric_families");
        this.families = res.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to load fabric families");
        }
      }
    },

    showCreateDialog() {
      this.editId = null;
      this.family = {
        id: null,
        title_en: null,
        title_th: null,
        title_de: null,
        domain: null,
        hex_code: null,
      };
      show_modal("#modal-box");
    },

    showUpdateDialog(index) {
      var data = this.families[index];
      this.family = {
        title_en: data.title_en,
        title_th: data.title_th,
        title_de: data.title_de,
        domain: data.domain,
        hex_code: data.hex_code,
      };
      this.editId = data.id;
      show_modal("#modal-box");
    },

    async createFamily() {
      try {
        let res = await axios.post("v2/fabrics/fabric_families", this.family);
        if (res.data.status === "OK") {
          this.getFabricFamilies();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async updateFamily() {
      try {
        let res = await axios.put(
          "v2/fabrics/fabric_families/" + this.editId,
          this.family
        );
        if (res.data.status === "OK") {
          this.getFabricFamilies();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Duplicate ID exist");
        }
      }
    },

    async deleteFamily(index) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        html:
          '<p class="text-danger">If the fabric family is deleted, the fabric books related to this family will not be updated automatically anymore.\n' +
          " Please notify the development team after you delete this.</p>",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });

      if (!result.value) {
        return;
      }
      try {
        let data = this.families[index];
        let res = await axios.delete("v2/fabrics/fabric_families/" + data.id);
        if (res.data.status === "OK") {
          this.families.splice(index, 1);
          toastr.success("SUCCESS");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "Unable to delete this fabric family, contact the admins for help!"
          );
        }
      }
    },
    onImageUploadFailed(error) {
      let errorMessage = error.response.data.message; // Set default error message
      if (error.response.status === 422) {
        // Error triggered by request validation
        if (error.response.data.errors.hasOwnProperty(field)) {
          errorMessage = error.response.data.errors[field].join(", ");
        }
      } else if (error.response.status === 413) {
        // Error triggered by HTTP server (Apache/Nginx) configutation
        errorMessage = "Image size is too large";
      }
      toastr.error(errorMessage);
    },
  },
};
</script>


<style scoped>
.color-prev {
  height: 50px;
  width: 50px;
  border-radius: 50px;
  margin: 0 auto;
}
</style>
